import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { EditalCota, EditalCotaRequest, StageExemptionRequest } from '@/models';

@Injectable({
  providedIn: 'root',
})
export class EditalIsencoesService {
  private baseUrl = `${environment.apiUrl}/admin/editais`;

  constructor(private http: HttpClient) {}

  deleteStageExemption(editalId: number, exemptionId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${editalId}/isencoes/${exemptionId}`);
  }

  updateStageExemption(editalId: number, exemptionId: number, data: StageExemptionRequest): Observable<StageExemptionRequest> {
    return this.http.put<StageExemptionRequest>(`${this.baseUrl}/${editalId}/isencoes/${exemptionId}`, data);
  } 
}
